<form class="app-search nav-profile-text">
    <div class="position-relative">
        <input type="text" id="{{id}}" class="form-control" placeholder="{{'global_search-placeholder' | translate}}" [attr.value]="value">
        <span class="mdi mdi-magnify"></span>
    </div>
</form>